<template>
    <div :class="[{'is_booked': isBooked},'registration_form', event.stop_registration || event.cancel || (event.transfer && event.transfer.length !== 0) ? 'short' : '' ]"
         v-if="event.need_register">
        <FormSuccessBg v-if="this.isBooked"/>
        <FormWaitingBg v-if="this.isWaiting"/>
        <template
                v-if="(event.max_register - event.count_register !== 0) && !event.stop_registration && !event.cancel && (event.transfer && event.transfer.length === 0) && !isBooked && !isWaiting && !isRefused">
            <div class="registration_form_request" v-if="!event.require_visit_reason">
                <div class="registration_form_left">
                    <div class="caption">Требуется предварительная запись</div>
                    <div class="slots" v-if="event.hide_number_of_available_setting != 1 && bookingError.length === 0">
                        Осталось: {{activeEventFreeSlots}} {{placesText}}
                    </div>
                    <div class="error_msg" v-if="bookingError">
                      {{bookingError}}
                    </div>
                </div>
                <div class="registration_form_right">
                    <EventModalPhoneForm @sendRegisrationRequest="sendRegisrationRequest"
                                         v-if="event.user.id === null"/>

                    <Button color="blue" size="m" :bg_color="this.bg" @click.native="sendRegisrationRequest"
                            v-if="event.user.id !== null && (event.reservation_status === null || event.reservation_status === 'late_cancel')">
                        Записаться
                    </Button>

                    <Button color="white" size="m" :bg_color="this.bg" @click.native="sendCancelRegistrationRequest"
                            v-if="event.user.id !== null && (event.reservation_status !== null && event.reservation_status !== 'late_cancel') && bookingError.length === 0">
                        Отменить запись
                    </Button>
                </div>

                <div class="registration_form_agree" v-html="this.agreeText"></div>
            </div>
            <div class="registration_form_request" v-if="event.require_visit_reason && event.user.id === null">
                <div class="registration_form_left empty_slot_form_left">
                    <div class="caption">Для записи на занятие требуется основание,<br>авторизуйтесь в личном
                        кабинете
                    </div>
                </div>
                <EnterButton class="enter-button btn btn-blue btn-m btn-custom-primary"
                             :additional-params="`/login?club_id=${event.club_id}&schedule_id=${event.event_id}`"/>
            </div>
            <div class="registration_form_request" v-if="event.reservation_status !== 'late_cancel' && event.require_visit_reason && !event.user.blocked && event.user.id !== null">
                <div class="registration_form_left empty_slot_form_left">
                    <div class="caption closed">
                        У вас нет оснований для записи<br>на это занятие
                    </div>
                </div>
              <a :href="`${domain}/lk/shop/schedule/${event.event_id}`" target="_blank">
                <Button color="blue" size="m" :bg_color="bg">
                  Купить и записаться
                </Button>
              </a>
            </div>
            <div class="registration_form_request" v-if="event.require_visit_reason && event.user.blocked && event.user.id !== null">
              <div class="registration_form_left empty_slot_form_left">
                <div class="caption closed">
                  Ваш аккаунт заблокирован.<br />Обратитесь в клуб для уточнения деталей
                </div>
              </div>
            </div>
        </template>
        <div class="registration_form_is_booked" v-else-if="isBooked">
            <div class="registration_form_is_booked_content">
                <div class="caption lg">Вы записаны!</div>
                <Button color="blue" size="m" @click.native="closeModal">
                    Вернуться к расписанию
                </Button>
            </div>
        </div>
        <div class="registration_form_is_booked" v-else-if="isWaiting">
            <div class="registration_form_is_booked_content">
                <div class="caption lg">Вы добавлены в лист ожидания!</div>
                <Button color="blue" size="m" @click.native="closeModal">
                    Вернуться к расписанию
                </Button>
            </div>
        </div>
        <div class="registration_form_is_booked" v-if="isRefused">
            <div class="registration_form_is_booked_content">
                <div class="caption lg">Запись отменена</div>
                <Button color="blue" size="m" @click.native="closeModal">
                    Вернуться к расписанию
                </Button>
            </div>
        </div>

        <template
                v-else-if="(event.stop_registration && event.time_open == '')|| event.cancel || (event.transfer && event.transfer.length !== 0) || (activeEventFreeSlots === 0 && !((event.max_register - event.count_register) === 0) && !isBooked && !isWaiting)">
            <div class="caption closed">Запись окончена</div>
        </template>
        <template v-else-if="event.stop_registration &&event.time_open !== ''">
            <div class="free_slots_error">Начало записи {{ event.time_open }}</div>
        </template>
        <template
                v-if="((event.max_register - event.count_register) === 0) && !event.stop_registration && !event.cancel && (event.transfer && event.transfer.length === 0) && !isBooked && !isWaiting && !isRefused">
            <div class="caption empty_slot">На данное занятие нет свободных мест.</div>
            <div class="registration_form_request" v-if="event.require_visit_reason && event.user.id === null">
              <div class="registration_form_left empty_slot_form_left">
                <div class="caption">Для записи на занятие требуется основание,<br>авторизуйтесь в личном
                  кабинете
                </div>
              </div>
              <EnterButton class="enter-button btn btn-blue btn-m btn-custom-primary"
                           :additional-params="`/login?club_id=${event.club_id}&schedule_id=${event.event_id}`"/>
            </div>

            <div class="registration_form_request" v-if="(event.reservation_status === null || event.reservation_status === 'late_cancel') && (event.user.id !== null || !event.require_visit_reason)">
                <div class="registration_form_left empty_slot_form_left">
                    <div class="caption">
                      Записаться в лист ожидания
                    </div>
                    <div class="error_msg" v-if="bookingError">
                      {{bookingError}}
                    </div>
                </div>
                <div class="registration_form_right">
                    <Button color="blue" size="m" :bg_color="this.bg" @click.native="sendRegisrationRequest"
                            v-if="event.user.id !== null">
                        Записаться
                    </Button>
                    <EventModalPhoneForm @sendRegisrationRequest="sendRegisrationRequest"
                                         v-if="!event.require_visit_reason && event.user.id === null"/>
                </div>

                <div class="registration_form_agree" v-html="this.agreeText"></div>
            </div>
            <div class="registration_form_request" v-if="event.reservation_status === 'waiting' || event.reservation_status === 'singed'">
                <div class="registration_form_left empty_slot_form_left">
                    <div class="caption" v-if="event.reservation_status === 'waiting'">Вы записаны в лист ожидания</div>
                    <div class="caption" v-if="event.reservation_status === 'singed'">Вы записаны!</div>
                </div>
                <div class="error_msg" v-if="bookingError">
                  {{bookingError}}
                </div>
                <div class="registration_form_right">
                    <Button color="white" size="m" :bg_color="this.bg" @click.native="sendCancelRegistrationRequest"
                            v-if="event.user.id !== null && event.reservation_status !== null && bookingError.length === 0">
                        Отменить запись
                    </Button>
                </div>

                <div class="registration_form_agree" v-html="this.agreeText"></div>
            </div>
        </template>


    </div>
</template>

<script>
    import EventModalPhoneForm from "./EventModalPhoneForm";
    import Button from "../Button";
    import {getWordDeclention} from "../../utils/text";
    import {storeToComputed} from "../mixins/storeToComputed";
    import FormSuccessBg from "../Images/FormSuccessBg";
    import FormWaitingBg from "../Images/FormWaitingBg";
    import EnterButton from "../Filters/EnterButton";

    export default {
        name: "EventModalRegistrationPanel",
        mixins: [storeToComputed],
        components: {
            EnterButton,
            EventModalPhoneForm,
            Button,
            FormSuccessBg,
            FormWaitingBg,
        },
        computed: {
            placesText() {
                return getWordDeclention(this.activeEventFreeSlots, ['место', 'места', 'мест']);
            },
            agreeText: function () {
                try {
                  let consent = this.$store.getters['events/consentPersonalData'];
                  let clubRules = this.$store.getters['events/clubRules'];
                  let offer = this.$store.getters['events/offer'];
                  let personalData = this.$store.getters['events/personalData'];

                  // "Согласие"
                  let consentText = 'согласие';
                  if (consent?.enable === true && consent.link) {
                    consentText = `<a href="${consent.link}" target="_blank">согласие</a>`;
                  }

                  // "обработка персональных данных"
                  let personalDataText = 'обработку персональных данных';
                  if (personalData?.enable === true && personalData.link) {
                    personalDataText = `<a href="${personalData.link}" target="_blank">обработку персональных данных</a>`;
                  }

                  // "Оферта"
                  let offerText = 'Офертой';
                  if (offer?.enable === true && offer.link) {
                    offerText = `<a href="${offer.link}" target="_blank">Офертой</a>`;
                  }

                  // "Правила клуба"
                  let clubRulesText = 'Правилами клуба';
                  if (clubRules?.enable === true && clubRules.link) {
                    clubRulesText = `<a href="${clubRules.link}" target="_blank">Правилами клуба</a>`;
                  }

                  return `Продолжая, вы даёте ${consentText} на ${personalDataText}. Соглашаетесь с ${offerText}, ${clubRulesText}.`;
                } catch (e) {
                  return '';
                }
            }
        },
        methods: {
            closeModal: function () {
                this.$emit('closeModal');
            },
            sendRegisrationRequest: function ({phoneNumber}) {
                let event = this.event;
                let eventId = event.event_id;
                let clubId = event.club_id;
                this.$store.dispatch('registration/registrationRequest', {
                    eventId,
                    phoneNumber,
                    clubId,
                    apiUrl: this.domain
                });
            },
            sendCancelRegistrationRequest: function () {
                let event = this.event;
                let eventId = event.event_id;
                this.$store.dispatch('registration/registrationCancelRequest', {eventId, apiUrl: this.domain});
            }
        },
        props: {
            event: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
    }
</script>
<style>
    #fitbase-widget .btn.enter-button > a {
        justify-content: center;
        color: #fff !important;
    }
    #fitbase-widget .btn.enter-button > a i path {
        fill: #fff !important;
    }
    .registration_form_request{
        flex-wrap: wrap;
    }
    .registration_form_agree{
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
</style>
